import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getSkillsFromStore,
  addSkillToUser,
  filterSearchItem,
  automationSearch,
  helperSearch,
  getDraftSkills,
  searchSkillStore,
} from "../../../../redux/actions/skill";
import { withRouter } from "react-router";
import { compose } from "redux";
import SkillItem from "../components/SkillItem";
import EmptyLoader from "../../../../components/emptyLoader";
import Loader from "../../../../components/loader";
import InfiniteScroll from "react-infinite-scroll-component";
import { notify } from "../../../../redux/actions/snack";
import backArrow from "../../../../images/back-arrow.png";
import HelperItem from "./HelperItem";
import OwlCarousel from "react-owl-carousel";
import navIcon from "../../../../images/nav-icon.svg";
import { Col, Row } from "antd";
class SearchResults extends Component {
  constructor() {
    super();
    this.state = {
      skills: [],

      isLoading: true,
    };
  }

  componentDidMount() {
    this.getSearchResults();
  }

  getSearchResults = async () => {
    var query = this.props.match.params.id;

    let page = 1;
    let data = { query, page };
    try {
      let skillFromeStore = await this.props.searchSkillStore(data);

      this.setState({
        isLoading: false,
        skills: skillFromeStore?.results,
      });
    } catch (err) {
      this.props.notify("error", "Something went wrong");
      this.setState({
        isLoading: false,
      });
    }
  };

  backtoggle() {
    this.props.history.goBack();
  }

  render() {
    const options = {
      // loop: true,
      margin: 15,
      nav: true,
      navText: [
        `<div class='sk-slide-nav owl-prev'><img src=${navIcon} /></div>`,
        `<div class='sk-slide-nav owl-next'><img src=${navIcon} /></div>`,
      ],
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 3,
        },
      },
    };

    return (
      <React.Fragment>
        <div>
          {this.state.isLoading ? (
            <div class="empty-view">
              <Loader
                styles={{ width: "80px", margin: "auto" }}
                root={{ display: "flex" }}
              />
            </div>
          ) : this.state.skills.length ? (
            <div className="sk-slide-section">
              <h4 className="tp-title">Search Results</h4>
              {/* <OwlCarousel
                className="owl-theme sk-boxes"
                id="sk-boxes1"
                {...options}
              >
                {this.state.skills.map((skill, index) => (
                  <SkillItem item={skill} key={index} />
                ))}
              </OwlCarousel> */}
              <div className="single-task-page">
                <Row gutter={15}>
                  {this.state.skills.map((skill, index) => (
                    <Col xs={24} sm={24} md={12} lg={8} key={index}>
                      <SkillItem item={skill} key={index} />
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          ) : (
            <EmptyLoader message="No results found" />
          )}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  skills: state.skillReducer,
  userReducer: state.userReducer,
  searchTerm: state.searchTerm,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getSkillsFromStore,
    addSkillToUser,
    filterSearchItem,
    notify,
    automationSearch,
    helperSearch,
    getDraftSkills,
    searchSkillStore,
  })
)(SearchResults);
